import {
  OreButton,
  OreDivider,
  OreHeading,
  OreStack,
  SvgPlus,
} from '@edenredespana/oreneta'
import { useTranslation } from 'react-i18next'
import { createApiBankAccountRepository } from '@/Contract/infrastructure'
import { AccountProvider } from '@/Contract/ui/context'
import { AccountingStatusBanner } from '@/Contract/ui/molecules'
import { createApiInvoiceRepository } from '@/Invoices/infrastructure'
import { InvoiceProvider } from '@/Invoices/ui/context'
import { WebTagPermissionEnum } from '@/Shared/domain'
import { navigationRoutes } from '@/Shared/ui/routers'
import { createApiTpvRepository } from '@/Store/infrastructure'
import { TpvProvider } from '@/Store/ui/context'
import { TpvsList } from '@/Store/ui/organisms'
import { storesTranslation } from '@/Store/ui/storesTranslation'
import { useWebTagPermissions } from '@/User/context'
import { useUserData } from '@/User/ui/context'
import { useEffect, useRef } from 'react'
import { AddTpvModalActions, AddTpvModal } from '@/Store/ui/molecules'
import { useNavigate } from 'react-router-dom'

export const TpvsPageContainer = (): JSX.Element => {
  const { t } = useTranslation()
  const { merchant } = useUserData()
  const { hasPermission } = useWebTagPermissions()
  const ref = useRef<AddTpvModalActions>(null)
  const navigate = useNavigate()

  const handleAddTpvClick = () => {
    if (merchant?.isParent) {
      navigate(navigationRoutes.tpvsExcelUpload)
    }
    else {
      ref.current?.open()
    }
  }

  useEffect(() => {
    if (merchant?.isMasterGroup) {
      window.location.href = navigationRoutes.home
    }
  }, [])

  return (
    <AccountProvider
      merchantId={merchant.id}
      repository={createApiBankAccountRepository()}
      origin={navigationRoutes.home}
    >
      <InvoiceProvider repository={createApiInvoiceRepository()}>
        <TpvProvider repository={createApiTpvRepository()} id={merchant.id}>
          <OreStack direction="column" space="2xsmall" placeContent="stretch">
            <OreStack
              direction="row"
              placeContent="space-between"
              style={{ paddingBottom: '8px' }}>
              <OreHeading as="h1" size="title-sm">
                {t(storesTranslation.tpvs.pageTitle)}
              </OreHeading>
              <OreButton
                data-testid="addTpv"
                category="primary"
                icon={<SvgPlus />}
                iconAlign="left"
                onClick={handleAddTpvClick}
                style={{ maxWidth: '235px' }}
              >
                {t(storesTranslation.tpvs.list.add)}
              </OreButton>
            </OreStack>
            <OreDivider space="medium" />
            <OreStack direction="column" space="medium" placeContent="stretch">
              {hasPermission(WebTagPermissionEnum.ACTION_BANK_ACCOUNT_CHANGE) && (
                <AccountingStatusBanner origin={navigationRoutes.storeTPV} />
              )}
              <OreStack direction="column" space="2xlarge" placeContent="stretch">
                <TpvsList tpvModalRef={ref} />
              </OreStack>
            </OreStack>
            <AddTpvModal ref={ref} />
          </OreStack>
        </TpvProvider>
      </InvoiceProvider>
    </AccountProvider>
  )
}
